import styled from '@emotion/styled';
import { ScrollLeftButton, ScrollRightButton } from 'src/domains/layouts/shared/ScrollButtons.style';
import { withConfig } from 'src/withConfig';

export const ScrollArrowsWrapper = withConfig(theme => styled('nav', { label: 'ScrollArrowsWrapper' })`
    align-self: flex-start;
    color: ${theme.star.customScrollBar.arrow.txtColor};
    display: flex;
    flex: 0 0 50px;
    height: 22px;
    position: absolute;
    right: 8px;
    top: 20px;
    width: 50px;
    z-index: ${theme.star.zIndexGlobal.base};
`);

interface ArrowBtnWrapperPropsType {
    isAvailable: boolean;
    isLastCard?: boolean;
}

export const ScrollLeft = styled(ScrollLeftButton, { label: 'ScrollLeft' })<ArrowBtnWrapperPropsType>`
    display: ${({ isAvailable }): string => isAvailable ? 'flex' : 'none'};
    left: ${({ isLastCard }): string => isLastCard === true ? 'auto' : '0'};
    right: ${({ isLastCard }): string => isLastCard === true ? '8px' : 'auto'};
    top: 0;
    transform: none;
`;

export const ScrollRight = styled(ScrollRightButton, { label: 'ScrollRight' })<ArrowBtnWrapperPropsType>`
    display: ${({ isAvailable }): string => isAvailable ? 'flex' : 'none'};
    right: 0;
    top: 0;
    transform: none;
`;
